import { AfterViewInit, Component, inject } from '@angular/core';
import { BaseListComponent } from '../base-list/base-list.component';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { MenuItem, MessageService, SharedModule } from 'primeng/api';
import { Topic } from '../../../models/topic';
import { TopicStore } from '../../../stores/topic/topic.state';
import { SidebarService } from '../../../services/menu/sidebar.service';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { ConfirmationDialogService } from '../../../services/confirmation-dialog.service';
import { RoutingService } from '../../../services/routing.service';
import { BadgeModule } from 'primeng/badge';
import { HeaderComponent } from '../../atoms/header/header.component';
import { MaskComponent } from '../mask/mask.component';
import { NgIf } from '@angular/common';
import { SidebarModule } from 'primeng/sidebar';
import { TableCaptionComponent } from '../../molecules/table-list-caption/table-list-caption.component';
import { TableListActionsComponent } from '../../molecules/table-list-actions/table-list-actions.component';
import { TableModule } from 'primeng/table';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { ActiveUserStore } from '../../../stores/user/active-user.state';

@Component({
  selector: 'app-topic-administration',
  standalone: true,
  imports: [
    BadgeModule,
    HeaderComponent,
    MaskComponent,
    NgIf,
    RouterOutlet,
    SharedModule,
    SidebarModule,
    TableCaptionComponent,
    TableListActionsComponent,
    TableModule,
    AlertComponent,
    RouterLink,
  ],
  templateUrl: './topic-administration.component.html',
  styleUrl: './topic-administration.component.scss',
})
export class TopicAdministrationComponent
  extends BaseListComponent<Topic>
  implements AfterViewInit
{
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-8',
    icon: 'fas fa-book-open',
    headerText: 'Themen',
  };

  readonly store = inject(TopicStore);
  readonly activeUserStore = inject(ActiveUserStore);
  override menuItems: MenuItem[] = [];
  override sidebarId = 'topic-administration';

  constructor(
    protected sidebarService: SidebarService,
    router: Router,
    route: ActivatedRoute,
    messageService: MessageService,
    confirmationDialogService: ConfirmationDialogService,
    routingService: RoutingService
  ) {
    super(
      router,
      route,
      messageService,
      confirmationDialogService,
      routingService
    );
  }

  /**
   * A lifecycle hook that is called after Angular has fully initialized
   * the component's view. This method performs a configuration setup
   * for the sidebar service by passing the specified sidebar configuration.
   *
   * @return {void} No return value.
   */
  ngAfterViewInit(): void {
    this.sidebarService.setConfiguration(this.sidebarConfig);
  }
}
